// Displaying Data from NocoDB -- Just for testing purposes
import React, { useEffect, useState } from "react";

const CustomersTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [search, setSearch] = useState("");
const [sortOrder, setSortOrder] = useState("asc");
const [sortField, setSortField] = useState("id");

  const limit = 10;

  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await fetch(
        `https://dshb-deposits.its.uiowa.edu/api/customers?page=${page}&limit=${limit}&search=${search}`
      );

      const json = await res.json();

      setData(json?.list || []);

    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  fetchData();
}, [page, search]);

  const fetchData = async (pageNum, searchText = search, sort = sortField, order = sortOrder) => {
  setLoading(true);

  try {
    const res = await fetch(
      `https://dshb-deposits.its.uiowa.edu/api/customers?page=${pageNum}&limit=${limit}` +
      `&search=${searchText}&sort=${sort}&order=${order}`
    );

    const json = await res.json();

    setData(json?.list || []);
    setTotalPages(Math.ceil((json?.pageInfo?.totalRows || 0) / limit));

  } catch (err) {
    console.error(err);
  }

  setLoading(false);
};

  useEffect(() => {
    fetchData(page);
  }, [page]);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Customers</h2>
  <input
  type="text"
  placeholder="Search..."
  value={search}
  onChange={(e) => {
    setSearch(e.target.value);
    setPage(1);
  }}
/>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table border="1" cellPadding="8" width="100%">
          <thead>
            <tr>
              <th onClick={() => {
  const newOrder = sortOrder === "asc" ? "desc" : "asc";
  setSortOrder(newOrder);
  setSortField("id");
  fetchData(page, search, "id", newOrder);
}}>
  ID ↕
</th>

<th onClick={() => {
  const newOrder = sortOrder === "asc" ? "desc" : "asc";
  setSortOrder(newOrder);
  setSortField("name");
  fetchData(page, search, "name", newOrder);
}}>
  Name ↕
</th>
              <th>Email</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, index) => (
                <tr key={index}>
                <td>{item.id || item.Id || "-"}</td>
                <td>{item.name || item.Name || item.customer_name || "-"}</td>
                <td>{item.email || item.Email || item.customer_email || "-"}</td>
                </tr>
            ))}
            </tbody>
        </table>
      )}

      {/* Pagination */}
      <div style={{ marginTop: "15px" }}>
        <button
          onClick={() => setPage((p) => Math.max(p - 1, 1))}
          disabled={page === 1}
        >
          Prev
        </button>

        <span style={{ margin: "0 10px" }}>Page {page}</span>

        <button
            onClick={() => setPage((p) => p + 1)}
            disabled={page >= totalPages}
            >
        Next
        </button>
      </div>
    </div>
  );
};

export default CustomersTable;